<template>
  <div class="caseStatistics">
    <div class="top wbg" v-if='$common.AUTH("statis:cancel:lists")'>
      <a-row class="row" :gutter="40">
        <a-col :span="6" class="flex">
          <label>委托类型：</label>
          <a-select placeholder="请选择" class="select">
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select class="select" v-model="form.accuser_id" placeholder="请选择" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='12' allowClear :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>管辖法院：</label>
          <a-select class="select" v-model="form.court_id" placeholder="请选择" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='14' @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
            :filter-option="false" :not-found-content="null" allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>作废情况：</label>
          <a-select v-model="form.cause_status" placeholder="请选择" class="select" allowClear>
            <a-select-option value="2">单一案件已作废</a-select-option>
            <a-select-option value="4">多条案件部分作废</a-select-option>
            <a-select-option value="5">多条案件全部作废</a-select-option>
          </a-select>
        </a-col>
        <!-- <a-col :span="6" class="flex">
          <label>是否全部作废：</label>
          <a-select v-model="form.is_invaild" placeholder="请选择" style="width:100%;" allowClear>
            <a-select-option value="1">是</a-select-option>
            <a-select-option value="2">否</a-select-option>
          </a-select>
        </a-col> -->
      </a-row>
      <a-row class="row" :gutter="40">
        <a-col :span="6" class="flex">
          <label>债务人：</label>
          <a-input v-model="form.realname" placeholder='请输入债务人姓名'> </a-input>
        </a-col>
        <a-col :span="6" class="flex">
          <label>债务人证件号码：</label>
          <a-input v-model="form.chinaid" placeholder='请输入债务人证件号码'> </a-input>
        </a-col>
        <a-col :span='6' style="display: flex; ">
          <a-button icon="search" @click="form.page = 1; query(1)" type='primary' style="height:32px;">查询</a-button>
          <a-button style="height:32px;margin-left: 20px;" @click="reset">重置</a-button>
          <a-button icon="upload" type='primary' ghost style="height:32px;margin-left:20px;" @click="out"
            v-if='$common.AUTH("export:cancen:cause")'>导出</a-button>
        </a-col>
      </a-row>
      <!-- <div class="group">
        <div class="btns">
          <a-button icon="search" @click="form.page=1;query(1)">查询</a-button>
        </div>
      </div> -->
    </div>
    <div class="tcon wbg" style="padding-top: 20px;">
      <div class="tableList" v-if='$common.AUTH("statis:cancel:lists")'>
        <div class="table">
          <table>
            <thead>
              <td width='60'>序号</td>
              <td width='80'>债务人</td>
              <td width='106'>债务人证件号码</td>
              <td width='68'>所属案件</td>
              <td width="180">管辖法院</td>
              <td width="150">作废原因</td>
              <td width="144">原告</td>
              <td width="80" style="text-align:center;">作废时间</td>
            </thead>
            <tbody>
              <tr v-for='(i, index) in newO.list' :key='index'>
                <td>{{ index + 1 + (10 * (form.page - 1)) }}</td>
                <td><span class="curpoter" @click='dbclick(i)'>
                    <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                  </span></td>
                <td>{{ i.chinaid }}</td>
                <td>
                  <p v-for='j in i.cause'>
                    案件{{ j.sort }}
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause'>
                    <Normap :tit='j.court'>{{ j.court }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause'>
                    <Normap :tit='j.invaild_reason'>{{ j.invaild_reason }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause'>
                    <Normap :tit='j.accuser.title'>{{ j.accuser.title }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause' style="text-align:center;padding-right:0;">
                    <span v-if="j.invaild_time"> {{ j.invaild_time.slice(0, 10) }}</span>
                  </p>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="form.page" show-quick-jumper :total="newO.count" show-less-items :pageSize='10'
            @change='turnpage' :show-total="(total) => `债务人：${newO.count} 案件数：${newO.cause_count}`" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import { invaildList, getAccuserAll } from "@/server/api"
import { getDirectory } from "@/server/directory"
import { Tacitly } from '@/assets/js/Tacitly'
export default {
  data() {
    return {
      accuserList: [],
      courtList: [],
      form: {
        accuser_id: [],
        realname: '',
        chinaid: '',
        is_invaild: undefined,
        page: 1,
        cause_status: undefined,
        limit: 10
      },
      newO: {
        cause_count: 0,
        list: [],
        count: 0
      },
      data: [],
      total: 0,
    }
  },
  created() {
    this.query()
    this.getAccuser()
  },
  methods: {
    handleSearch(val) {
      getDirectory({ limit: 100, title: val }).then((res) => {
        this.courtList = res.list
      })
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    turnpage(val) {
      this.form.page = val;
      this.query()
    },
    getAccuser() {
      getAccuserAll().then((res) => {
        this.accuserList = res.list
      })
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      invaildList(form).then(res => {
        this.newO = res
      })
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.accuser_id = []
      this.form.court_id = []
      this.form.cause_status = undefined
      this.form.realname = ''
      this.form.chinaid = ''
      this.query()
    },
    out(type, bool) {
      let http = Tacitly.Base_Port
      const form = JSON.parse(JSON.stringify(this.form));
      for (let val in form) {
        if (typeof form[val] == 'object') {
          form[val] = form[val].toString()
        }
      }
      delete form.page
      delete form.limit
      this.$modal.confirm({
        content: '确认导出这个文件？',
        onOk: () => {
          window.open(http + 'export/invaildCause?' + this.$common.urlEncode(form))
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.caseStatistics {
  padding-bottom: 50px;
  @import url('@/assets/css/search.less');
}

.caseStatistics {
  padding-bottom: 50px;

  .top {
    padding: 20px 20px 0;
    overflow: hidden;

    .group {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 72px;

      .label {
        display: flex;
        align-items: center;
        flex: 1;
        width: 25%;
        margin-right: 0;
        padding-right: 20px;
        white-space: nowrap;
      }

      .put {
        width: 90%;
      }
    }

    .to {
      display: inline-block;
      width: 20px;
      height: 1px;
      margin: 0 10px;
      background-color: #dbdcde;
      vertical-align: middle;
    }

    form {
      width: 100%;
    }

    .label {
      display: block;
      margin-right: 30px;
      font-size: 14px;
      color: #0e2949;
      float: left;
    }

    .btns {
      float: right;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 24px;
        color: #1e8bfe;
      }

      .span {
        margin-left: 20px;
      }

      button {
        margin-left: 40px;
        min-width: 90px;
      }
    }
  }
}

.tcon {
  padding: 0 20px;
  min-height: 720px;

  .tableList {
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 10px 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .pages {
    text-align: right;
    position: relative;
  }
}
</style>
